import { PreferenceFamily } from '@/creditflowresearch/domain/Preferences/PreferenceFamily';
import { EUROPEAN_MARKET_ID, US_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';
import { APAC_REGION_ID, EMEA_REGION_ID, LATM_REGION_ID, USOA_REGION_ID } from '@/creditflowresearch/domain/Region/constants';

export type MappingTargetFamily =
  | PreferenceFamily.ABS
  | PreferenceFamily.CORPORATE
  | PreferenceFamily.EM;

const ABS_REGION_ORDER: string[] = [USOA_REGION_ID, EMEA_REGION_ID, APAC_REGION_ID, LATM_REGION_ID];
const CORPORATE_MARKET_ORDER: string[] = [US_MARKET_ID, EUROPEAN_MARKET_ID];
const EM_REGION_ORDER: string[] = [EMEA_REGION_ID, APAC_REGION_ID, LATM_REGION_ID];

export interface ITargetFamilyConfig {
  canonicalOrder: string[],
  fallbackWhenNothingMapped: string[],
  menuSingleSelectPriority: string[],
}

export const TARGET_FAMILY_CONFIG: Record<MappingTargetFamily, ITargetFamilyConfig> = {
  [PreferenceFamily.ABS]: {
    canonicalOrder: ABS_REGION_ORDER,
    fallbackWhenNothingMapped: [USOA_REGION_ID],
    menuSingleSelectPriority: [USOA_REGION_ID, EMEA_REGION_ID, LATM_REGION_ID, APAC_REGION_ID],
  },
  [PreferenceFamily.CORPORATE]: {
    canonicalOrder: CORPORATE_MARKET_ORDER,
    fallbackWhenNothingMapped: [US_MARKET_ID],
    menuSingleSelectPriority: [US_MARKET_ID, EUROPEAN_MARKET_ID],
  },
  [PreferenceFamily.EM]: {
    canonicalOrder: EM_REGION_ORDER,
    fallbackWhenNothingMapped: EM_REGION_ORDER,
    menuSingleSelectPriority: [],
  },
};

export interface ISourceIdMapping {
  id: string,
  mapsTo: Partial<Record<MappingTargetFamily, string[]>>,
}

export const SOURCE_ID_MAPPINGS: Record<MappingTargetFamily, ISourceIdMapping[]> = {
  [PreferenceFamily.ABS]: [
    {
      id: USOA_REGION_ID,
      mapsTo: {
        [PreferenceFamily.CORPORATE]: [US_MARKET_ID],
        [PreferenceFamily.EM]: [],
      },
    },
    {
      id: EMEA_REGION_ID,
      mapsTo: {
        [PreferenceFamily.CORPORATE]: [EUROPEAN_MARKET_ID],
        [PreferenceFamily.EM]: [EMEA_REGION_ID],
      },
    },
    {
      id: APAC_REGION_ID,
      mapsTo: {
        [PreferenceFamily.CORPORATE]: [],
        [PreferenceFamily.EM]: [APAC_REGION_ID],
      },
    },
    {
      id: LATM_REGION_ID,
      mapsTo: {
        [PreferenceFamily.CORPORATE]: [],
        [PreferenceFamily.EM]: [LATM_REGION_ID],
      },
    },
  ],
  [PreferenceFamily.CORPORATE]: [
    {
      id: US_MARKET_ID,
      mapsTo: {
        [PreferenceFamily.ABS]: [USOA_REGION_ID],
        [PreferenceFamily.EM]: [],
      },
    },
    {
      id: EUROPEAN_MARKET_ID,
      mapsTo: {
        [PreferenceFamily.ABS]: [EMEA_REGION_ID],
        [PreferenceFamily.EM]: [EMEA_REGION_ID],
      },
    },
  ],
  [PreferenceFamily.EM]: [
    {
      id: EMEA_REGION_ID,
      mapsTo: {
        [PreferenceFamily.ABS]: [EMEA_REGION_ID],
        [PreferenceFamily.CORPORATE]: [EUROPEAN_MARKET_ID],
      },
    },
    {
      id: APAC_REGION_ID,
      mapsTo: {
        [PreferenceFamily.ABS]: [USOA_REGION_ID, APAC_REGION_ID],
        [PreferenceFamily.CORPORATE]: [],
      },
    },
    {
      id: LATM_REGION_ID,
      mapsTo: {
        [PreferenceFamily.ABS]: [USOA_REGION_ID, LATM_REGION_ID],
        [PreferenceFamily.CORPORATE]: [US_MARKET_ID],
      },
    },
  ],
};

export interface IMappingException {
  sourceIds: string[],
  targetIds: string[],
}

export const MAPPING_EXCEPTIONS:
Partial<Record<MappingTargetFamily, Partial<Record<MappingTargetFamily, IMappingException[]>>>> = {
  [PreferenceFamily.EM]: {
    [PreferenceFamily.ABS]: [
      {
        sourceIds: [EMEA_REGION_ID, APAC_REGION_ID],
        targetIds: [EMEA_REGION_ID, APAC_REGION_ID],
      },
    ],
  },
};
